module.exports = __webpack_public_path__ + "static/media/minus-circle.3df54807.svg";